import axios from 'axios'

const Axios = axios.create({
  // timeout: 10000,
  // 允许跨域请求
  withCredentials: true,
})

//POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(config => {
    // 在发送请求之前做某件事
    // if(config.method  === 'post'){
    //     // JSON 转换为 FormData
    //     const formData = new FormData()
    //     Object.keys(config.data).forEach(key => formData.append(key, config.data[key]))
    //     config.data = formData
    // }

    // 下面会说在什么时候存储 token
    // if (sessionStorage.token) {
    //     config.headers.Authorization = sessionStorage.token
    // }
    return config;
},error =>{
    return Promise.reject(error)
})

//返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(res =>{
    //需要登陆
    if(res.data.code == 401 || res.data.code == 402 || res.data.code == 403) {
      // 清除登录状态
      const prefix = 'wcy'
      // 清除 localStorage
      const localData = JSON.parse(localStorage.getItem(prefix)) || {}
      delete localData.token
      delete localData.userInfo
      delete localData.userPermissions
      localStorage.setItem(prefix, JSON.stringify(localData))
      
      // 清除 sessionStorage
      const sessionData = JSON.parse(sessionStorage.getItem(prefix)) || {}
      delete sessionData.token
      delete sessionData.userInfo
      delete sessionData.userPermissions
      sessionStorage.setItem(prefix, JSON.stringify(sessionData))
      
      // 跳转登录页
      window.location = "/login";
      return ;
    }
    return res
}, error => {
    return Promise.reject(error)
})

Axios.install = (Vue) => {
  Vue.prototype.$http = Axios
}

export default Axios



// WEBPACK FOOTER //
// ./src/libs/AxiosPlugin.js